/**
 * DevExtreme (esm/__internal/ui/form/components/empty_item.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../../core/renderer";
export const FIELD_EMPTY_ITEM_CLASS = "dx-field-empty-item";
export function renderEmptyItem(info) {
  const {
    $parent: $parent,
    rootElementCssClassList: rootElementCssClassList
  } = info;
  return $("<div>").addClass("dx-field-empty-item").html("&nbsp;").addClass(rootElementCssClassList.join(" ")).appendTo($parent);
}